/** Mobile / in-app browsers: popup OAuth is unreliable; use redirect. */
export function prefersGoogleAuthRedirect(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (/Android|iPhone|iPad|iPod|Mobile|IEMobile|Opera Mini/i.test(ua)) return true;
  if (/FBAN|FBAV|Instagram|Line\//i.test(ua)) return true;
  if (typeof window.matchMedia === "function") {
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    const noHover = window.matchMedia("(hover: none)").matches;
    if (coarse && noHover) return true;
  }
  return false;
}

function getFirebaseAuthCode(err: unknown): string | null {
  if (typeof err !== "object" || err === null) return null;
  const code = (err as { code?: unknown }).code;
  return typeof code === "string" ? code : null;
}

export function isGooglePopupBlockedError(err: unknown): boolean {
  const code = getFirebaseAuthCode(err);
  return code === "auth/popup-blocked" || code === "auth/cancelled-popup-request";
}

export function isGoogleRedirectFallbackError(err: unknown): boolean {
  const code = getFirebaseAuthCode(err);
  return (
    code === "auth/web-storage-unsupported" ||
    code === "auth/operation-not-supported-in-this-environment"
  );
}
